import setAdditionalMetaOptions from '@/js/common/Service/setAdditionalMetaOptions';
import getABTestValue from '@/js/common/Domain/Service/getABTestValue';
import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => requestService({
    cache: false,
    url: `${window.appConfig.apiGatewayUrl}/frontend/tours`,
    data: {
        ...tourCriteriaForTourRequest,
        ...setAdditionalMetaOptions(),
        allToursPerHotel: 1,
        sections: ['countries', 'rooms', 'operators', 'routes', 'legs', 'firstPaymentDefinitions', 'airlines'],
        abTests: getABTestValue(),
    },
}, callback);